// 倒计时
var systemTime = 0;
var timers = [];
var running = false;
var localStartTime = 0; // 本地初始化的时间，用来记录本地时间间隔，计算出系统时间
var res = $.extend({}, response);

systemTime = res.now / 1000;
localStartTime = new Date().getTime();

function start (loop) {
    running = true;
    run(loop);
}

function run (loop) {
    if (!timers.length) {
        running = false;
        return;
    }

    var localSpan = new Date().getTime() - localStartTime;
    var lastSystemTime = systemTime + Math.floor(localSpan / 1000);

    for (var i = 0; i < timers.length; i++) {
        var myTime = timers[i].time / 1000;
        var overD = Math.floor((myTime - lastSystemTime) / 60 / 60 / 24);
        var overH = Math.floor((myTime - lastSystemTime) / 60 / 60 - overD * 24);
        var overM = Math.floor((myTime - lastSystemTime) / 60 - overD * 24 * 60 - overH * 60);
        var span = {
            d: overD,
            h: overH,
            m: overM
        };

        for (var k in span) {
            if (span[k] < 10) {
                span[k] = '0' + span[k];
            }
        }

        timers[i].render && timers[i].render(span);

        if (lastSystemTime >= myTime) {
            // 如果已经结束，不再进入计时循环
            timers[i].end && timers[i].end();
            timers.splice(i, 1);
            i--;
        }
    }
    loop && setTimeout(run, 1000 * 60);
}

module.exports = {
    init: function (time, render, end) {
        timers.push({
            render: render,
            time: time,
            end: end
        });
        if (!running) {
            start(true);
        } else {
            run();
        }
    },
    now: function () {
        return systemTime * 1000 + (new Date().getTime() - localStartTime);
    },
    startOfDay: function (time) {
        var date = new Date(time);

        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);

        return date.getTime();
    }
};


//////////////////
// WEBPACK FOOTER
// ./pages/new/js/timer.js
// module id = 2
// module chunks = 0